import React, { useEffect, useState, createElement } from 'react';
import { Clock } from 'lucide-react';
import { Hero, PainPoints, ProductReveal, WhatsInside, Bonuses, SocialProof, Guarantee, FAQ, Footer } from './components/Sections';
import { Offer } from './components/Offer';
import { PurchasePopup } from './components/PurchasePopup';
import { Button, TrustBadges } from './components/SharedUI';
import { usePricing } from './components/usePricing';
// Meta Pixel Hook
const useMetaPixel = () => {
  useEffect(() => {
    const pixelId = '1225428543097695';
    // Inject Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually pixel stays for the session
    };
  }, []);
};
export function App() {
  useMetaPixel();
  const {
    formattedPrice,
    formattedOldPrice
  } = usePricing();
  // 10 minutes and 43 seconds = 643 seconds
  const [timeLeft, setTimeLeft] = useState(643);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };
  const timeString = formatTime(timeLeft);
  return <div className="min-h-screen bg-navy-900 text-white font-sans flex flex-col" data-id="element-0">
      {/* Sticky Top Bar */}
      <div className="sticky top-0 z-40 bg-brand-red text-white py-2 px-4 shadow-lg flex justify-center items-center gap-2 md:gap-4 text-sm md:text-base font-bold" data-id="element-1">
        <span className="uppercase tracking-wide" data-id="element-2">
          ⚠️ Esta oferta termina pronto
        </span>
        <div className="flex items-center gap-1.5 bg-black/20 px-2.5 py-0.5 rounded-md" data-id="element-3">
          <Clock className="w-4 h-4" data-id="element-4" />
          <span className="font-mono" data-id="element-5">{timeString}</span>
        </div>
      </div>

      <main className="flex-grow" data-id="element-6">
        <Hero data-id="element-7" />
        <PainPoints data-id="element-8" />
        <ProductReveal data-id="element-9" />
        <WhatsInside data-id="element-10" />
        <Bonuses data-id="element-11" />
        <SocialProof data-id="element-12" />
        <Offer timeString={timeString} formattedPrice={formattedPrice} formattedOldPrice={formattedOldPrice} data-id="element-13" />
        <Guarantee data-id="element-14" />

        {/* Final CTA Section */}
        <section className="py-16 md:py-24 px-4 text-center bg-navy-800/50" data-id="element-15">
          <div className="max-w-2xl mx-auto" data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-17">
              Ya tienes el conocimiento.
            </h2>
            <p className="text-xl text-brand-green font-medium mb-10" data-id="element-18">
              Ahora necesitas el sistema que lo respalde.
            </p>

            <div className="flex justify-center items-center gap-2 mb-6 text-brand-red font-bold" data-id="element-19">
              <Clock className="w-5 h-5" data-id="element-20" />
              <span data-id="element-21">
                La oferta expira en:{' '}
                <span className="font-mono text-xl" data-id="element-22">{timeString}</span>
              </span>
            </div>

            <Button href="https://pay.hotmart.com/V105318931X?checkoutMode=10" className="mb-6 shadow-brand-green/30" data-id="element-23">
              ⚽ Conseguir el Megapack ahora — {formattedPrice}
            </Button>
            <TrustBadges data-id="element-24" />
          </div>
        </section>

        <FAQ data-id="element-25" />
      </main>

      <Footer data-id="element-26" />
      <PurchasePopup data-id="element-27" />
    </div>;
}